import React from "react"

import styles from "./service-questions-list.module.css"

export default function ServiceQuestionsList({ children }) {
  return <div className={styles.serviceQuestionsList}>{children}</div>
}
